import { Link } from "react-router-dom";

const Breadcrumb = ({ title,heading }) => {
  return (
    <section style={{marginTop:"100px", backgroundImage:"url('/assets/images/bg/bread-crumbs.png')", backgroundSize:'cover', backgroundPosition:'center', backgroundRepeat:'no-repeat'}} className='breadcrumb py-120 position-relative z-1 overflow-hidden mb-0'>
     
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8'>
            <div className='breadcrumb__wrapper' style={{textAlign:'left'}}>
              <h1 className='breadcrumb__title display-4 fw-semibold' style={{textAlign:'left'}}>
                {" "}
                {title}
              </h1>
              <ul className='breadcrumb__list d-flex align-items-center gap-4' style={{justifyContent:'flex-start'}}>
                <li className='breadcrumb__item'>
                  <Link
                    to='/'
                    className='breadcrumb__link text-neutral-500 hover-text-main-600 fw-medium'
                  >
                    <i className='text-lg d-inline-flex ph-bold ph-house' />{" "}
                    {heading?"Department":'Home'}
                  </Link>
                </li>

                <li className='breadcrumb__item '>
                  <i className='text-neutral-500 d-flex ph-bold ph-caret-right' />
                </li>
                <li className='breadcrumb__item'>
                  <span className='text-main-two-600'> {title} </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;
